import type { FC } from "react";
import React from "react";

import OfflineIndicator from "./OfflineIndicator";

const Shell: FC<{
  children: React.ReactNode;
  showGrid?: boolean;
  plain?: boolean;
  navigation?: React.ReactNode;
}> = ({ children, showGrid = true, plain = false, navigation }) => (
  <div
    className={`relative flex min-h-dvh flex-col ${plain ? "bg-surface" : "bg-primaryDarkBlue selection:bg-accentGreen/30"}`}
  >
    <OfflineIndicator />
    {/* Ambient background */}
    {showGrid && !plain && (
      <>
        <div className="pointer-events-none fixed inset-0 bg-gradient-to-b from-[#132d4f] via-primaryDarkBlue to-[#0a1a2e]" />
        <div className="pointer-events-none fixed inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(144,198,63,0.04)_0%,_transparent_60%)]" />
      </>
    )}
    {plain && navigation ? (
      <div className="bg-navy-strong">{navigation}</div>
    ) : (
      navigation
    )}
    {children}
    <div className="relative z-10 pb-6" />
    <style>{`
      @keyframes bc-fade-up {
        from { opacity: 0; transform: translateY(16px); }
        to { opacity: 1; transform: translateY(0); }
      }
      @keyframes bc-scale-in {
        0% { transform: scale(0); opacity: 0; }
        60% { transform: scale(1.1); opacity: 1; }
        100% { transform: scale(1); opacity: 1; }
      }
      @keyframes bc-pulse-ring {
        0% { transform: scale(0.8); opacity: 0.6; }
        100% { transform: scale(1.4); opacity: 0; }
      }
      @keyframes bc-shimmer {
        0% { background-position: -200% 0; }
        100% { background-position: 200% 0; }
      }
      .bc-fade-up { animation: bc-fade-up 0.5s cubic-bezier(0.16, 1, 0.3, 1) both; }
      .bc-fade-up-1 { animation-delay: 0.05s; }
      .bc-fade-up-2 { animation-delay: 0.1s; }
      .bc-fade-up-3 { animation-delay: 0.15s; }
      .bc-fade-up-4 { animation-delay: 0.2s; }
      .bc-fade-up-5 { animation-delay: 0.25s; }
      .bc-scale-in { animation: bc-scale-in 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.15s both; }
    `}</style>
  </div>
);

export default Shell;
